/*
	Компілюється у файл
*/
process.env.NODE_ENV === 'production' ? true : require('__page/project-mcingo.html');

/*
	Підключаєм конструктор модулів
*/
const mc = require('__libs/ModuleConstructor.js');
const Rellax = require('rellax');

/**
	Запускаєм конструктор модулів. Аргументом приймає масив назв vue-компонентів,
	які треба включити в процес збірки проекту.
	@type {Array<String>}
*/
mc(['Form', 'Navigation', 'Slider', 'List', 'Chart']);

var rellax = new Rellax('.rellax', {
	center: true
});

/*
	Запускаєм скріпти html компонентів
*/
STACK.forEach(f => {
	f($);
})



// WEBPACK FOOTER //
// ./entries/project-mcingo.js